export default __webpack_public_path__ + "static/media/1.e25d4834.jpg";